import smallLogo from '../../images/smallLogo.png';
import bigLogo from '../../images/bigLogo.png';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const [isActive, setIsActive] = useState(false);
  const [actualLanguage, setActualLanguage] = useState(localStorage.getItem('language') || 'English');
  const [isActiveLanguage, setIsActiveLanguage] = useState(false);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng, fulllng) => {
    setActualLanguage(fulllng);
    setIsActiveLanguage(false);
    i18n.changeLanguage(lng);
    localStorage.setItem('language', fulllng);
    localStorage.setItem('languageCode', lng);
  };

  return (
    <header className="header content-fix-index">
      <nav className={`nav ` + (isActive ? 'nav__active' : '')}>
         <img alt="logo" src={smallLogo} className='nav__logo'/>

          <div className="nav--fixblock">
            <ul className={`nav__list ` + (isActive ? 'nav__list_active' : '')}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                <a href="#" onClick={() => setIsActive(false)}>
                  <li className='nav__list_item'>{t('navGln')}</li>
                </a>
                <a href="#aboutus" onClick={() => setIsActive(false)}>
                  <li className='nav__list_item'>{t('navAboutUs')}</li>
                </a>
                <a href="#structur" onClick={() => setIsActive(false)}>
                  <li className='nav__list_item'>{t('navOtdel')}</li>
                </a>
                <a href="#vacancy" onClick={() => setIsActive(false)}>
                  <li className='nav__list_item'>{t('navVacancy')}</li>
                </a>
                <a href="#contactus" onClick={() => setIsActive(false)}>
                  <li className='nav__list_item'>{t('navContact')}</li>
                </a>
            </ul>
            <div className='nav__list_language'>
              <div onClick={() => {setIsActiveLanguage(prev => !prev); setIsActive(false);}} className='nav__list_language-plaseholder'>{actualLanguage}</div>
              <div className={'nav__list_language-options ' + (isActiveLanguage ? ' options-active' : '')}>
                <div onClick={() => changeLanguage('en', 'English')}>English</div>
                <div onClick={() => changeLanguage('ua', 'Українська')}>Українська</div>
                <div onClick={() => changeLanguage('ru', 'Русский')}>Русский</div>
              </div>
            </div>
          </div>

          <div className='nav__burgermenu' onClick={() => {setIsActive(prev => !prev); setIsActiveLanguage(false);}}>
            <div></div>
            <div></div>
            <div></div>
          </div>
      </nav>

      <img className='header__logo' alt='logo' src={bigLogo} />

      <div className='header__info'>
        <div className='header__info_text header__info_text-first'>{t('headerTextFirst', { returnObjects: true })[0]}<br/>{t('headerTextFirst', { returnObjects: true })[1]}</div>
        <div className='header__info_text header__info_text-second'>{t('headerTextSecond', { returnObjects: true })[0]}<br/>{t('headerTextSecond', { returnObjects: true })[1]}</div>
      </div>
      <a href="#team" className='header__button'>
        <div>
          {t('headerButton')}
        </div>
      </a>
    </header>
  );
};

export default Header;
